import React from "react";
import PropTypes from "prop-types";

const Undo2Icon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const resolvedStroke = stroke || color || "currentColor";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9 14 4 9l5-5"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Undo2Icon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Undo2Icon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default Undo2Icon;
